/*
 * @Author: Jing
 * @Date: 2021-11-05 11:10:59
 * @Descripttion:
 */
import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios'
import type { ResponseData } from '#/axios'
import { Toast } from 'vant'
import Router from '@/router'
import { storageGet } from '@/utils/util'

// let baseUrl:any = import.meta.env.VITE_API_BASE_URL
let instance = axios.create({
    // baseURL: baseUrl,
    timeout: 30000,
})

// 请求拦截器
instance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        return config
    },
    (err) => {
        console.log('请求失败')
        return Promise.reject(err)
    }
)

// 响应拦截器
instance.interceptors.response.use(
    (response: AxiosResponse) => {
        const data: ResponseData = response.data
        try {
            const code = data.code as string,
                message = data.desc || data.msg
            const isSucceed = _handleResCode(code, message)
            if (isSucceed) {
                return Promise.resolve(data)
            } else {
                return Promise.reject(data)
            }
        } catch (error) {
            console.log('fetch响应拦截器报错', error)
            return Promise.resolve(data)
        }
    },
    (error: any) => {
        Toast('网络服务错误，请刷新后再试')
        return Promise.reject(error)
    }
)

const _handleResCode = (code: string | number, message: string) => {
    if (code === '00' || code === 0) {
        // 请求成功
        return true
    } else if (code === '01') {
        console.log('token失效，需要重新登录')
        let curRoute = Router.currentRoute.value
        let bid = curRoute.query.brandId || storageGet('brandId')
        let url = '/authorize?brandId=' + bid + '&redir=' + encodeURIComponent(curRoute.fullPath)
        Router.push(url)
        return false
    } else {
        // 其他情况，统统提示message信息
        Toast(message)
        return false
    }
}

export default instance

export function searchParams(form: any, params: any): URLSearchParams {
    if (!params) params = new URLSearchParams()
    for (var key in form) {
        let val = form[key]
        if (val == undefined) continue
        if (Array.isArray(val)) {
            for (var i of val) {
                params.append(key, i)
            }
        } else {
            if (val instanceof File) {
                params.append(key, val)
            } else params.append(key, typeof val == 'object' ? JSON.stringify(val) : val)
        }
    }
    return params
}
